import(/* webpackMode: "eager" */ "/home/runner/work/vhire/vhire/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.60.0_react-_d42ba7598167114c09618396f6df1214/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["TenantLogo"] */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/ui/tenant-logo.tsx");
